import { render, staticRenderFns } from "./form-input2.vue?vue&type=template&id=0d812bd6&scoped=true&"
import script from "./form-input2.vue?vue&type=script&lang=js&"
export * from "./form-input2.vue?vue&type=script&lang=js&"
import style0 from "./form-input2.vue?vue&type=style&index=0&id=0d812bd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d812bd6",
  null
  
)

export default component.exports